import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 *
 */
class MaskingPolicyService {
  /**
   * @param page
   * @param keyword
   * @param orgId
   * @param limit
   * @param maskingPolicyId
   * @return {Promise<*>}
   */
     getMaskingPolicies = async (orgId, maskingPolicyId, page, limit) => {
       let url = `${Constants.MASKING_POLICY}?`;
       if (orgId) url += `org_id=${orgId}&`;
       if (page) url += `page=${page}&`;
       if (limit) url += `limit=${limit}&`;
       if (maskingPolicyId) url += `data_masking_policy_id=${maskingPolicyId}`;
       const maskingPolicys = await Helpers.get({ url });
       return maskingPolicys;
     }

     /**
      * @param maskingPolicyId
      * @param tenantId
      * @return {Promise<*>}
      */
     getMaskingPolicyById = async (orgId, maskingPolicyId) => {
       const maskingPolicy = await Helpers.get({
         url: `${Constants.MASKING_POLICY}?data_masking_policy_id=${maskingPolicyId}&org_id=${orgId}`,
       });
       return maskingPolicy;
     }

     /**
      *
      * @param payload
      * @return {Promise<void>}
      */
     createMaskingPolicy = async (payload) => {
       const createdMaskingPolicy = await Helpers.post({
         url: Constants.MASKING_POLICY,
         data: payload,
       });
       return createdMaskingPolicy;
     }

     /**
      * @param payload
      * @return {Promise<*>}
      */
     updateMaskingPolicy = async (payload) => {
       const maskingPolicy = await Helpers.put({
         url: Constants.MASKING_POLICY,
         data: payload,
       });
       return maskingPolicy;
     }

      /**
       *
       * @param {*} payload
       * @return
       */
      deleteMaskingPolicy = async (payload) => {
        const maskingPolicy = await Helpers.delete({
          url: Constants.MASKING_POLICY,
          data: payload,
        });
        return maskingPolicy;
      }

      /**
      * @return {Promise<*>}
      */
     getMaskingPolicyEditPage = async () => {
       const maskingPolicy = await Helpers.get({
         url: `${Constants.MASKING_POLICY}/editpage`,
       });
       return maskingPolicy;
     }
}

export default new MaskingPolicyService();
